import React from "react";
import ServiceGrid from "../components/ServiceGrid";

export default function Services() {
  return (
    <>
      <section className="page-hero compact">
        <p className="eyebrow">Services</p>
        <h1>Container destuffing, lumper crews, palletizing, and dock support.</h1>
        <p>Fairview CM helps warehouse teams handle inbound pressure without letting containers, trailers, or floor-loaded freight stall the operation.</p>
      </section>
      <ServiceGrid />
    </>
  );
}
